import Datastore from "@/developing/datastore";
import store from '@/store'; // Vuex store for import the module's states.
import local from "./data-local";
import dev from "./data-dev";

import moduleCalendar from "@/developing/store/modules/advisor/moduleCalendar.js";

//
export const state = { Datastore, store: store.state, local, dev }

// Methods to convert input data to be calendar oriented data
export const dataAdaptor = {
  event: () => {
    // console.log(input);
  }
};

//
export function prepare() {
  if (!store.state.calendar) { store.registerModule('calendar', moduleCalendar) }
}

//
export function refresh() {

}

//
export function cleanup() {
  store.unregisterModule('calendar');
}
